import * as React from "react";
import { Option } from "informed";
import { useWebPortalLegacyClient } from "../misc/api/WebPortalTokenClient";
import Modal, { ModalSize } from "../misc/components/modal";
import { Form, useFormApi } from "informed";
import { groupBy } from "lodash";
import { Dropdown } from "../forms/informedv2/Dropdown";
import { NotificationConfig } from "./ConfigureNotification";
import { NotificationPlugin } from "./NotificationTypes";
import Alert, { AlertCategoryEnum } from "../misc/components/Alert";
import { isModelWithError } from "../misc/api/apiTypes";

interface CreateNotificationProps {
    onClose: () => void;
}

export const CreateNotification = ({ onClose }: CreateNotificationProps) => {
    const [page, setPage] = React.useState(0);
    const [notificationPlugins, setNotificationPlugins] = React.useState<any[]>([]);
    const [selectedTemplate, setSelectedTemplate] = React.useState();
    const [error, setError] = React.useState<undefined | string>();
    const legacyClient = useWebPortalLegacyClient();

    React.useEffect(() => {
        const getPlugins = async () => {
            try {
                const notificationPluginsResult = await legacyClient.getNotificationPlugins();
                if (isModelWithError(notificationPluginsResult))
                    return setError("Failed to load the notification templates. Please contact an Administrator.");

                const grouped = groupBy(notificationPluginsResult, p => p.Category);

                setNotificationPlugins(Object.entries(grouped));
            } catch (ex) {
                setError("Failed to load the notification templates. Please contact an Administrator.");
            }
        }

        getPlugins();
    }, []);

    return (
        <Modal show={true} size={ModalSize.Large} closeModalHandler={onClose}>
            <Alert show={error !== undefined} category={AlertCategoryEnum.Danger}>{error}</Alert>
            {page === 0 ?
                <CreateNotificationSelectType notificationPlugins={notificationPlugins} setPage={() => setPage(1)} setTemplate={setSelectedTemplate} selectedTemplate={selectedTemplate} />
                : <NotificationConfig isEdit={false} selectedTemplate={selectedTemplate} onClose={onClose} />}
        </Modal>
    );
}

interface CreateNotificationSelectTypeProps {
    categorySelect: string;
}

export const CreateNotificationSelectTypeForm = ({ notificationPlugins, setPage, setTemplate, selectedTemplate }) => {
    const formApi = useFormApi<CreateNotificationSelectTypeProps>();
    const [filteredTemplates, setFilteredTemplates] = React.useState<any[]>([]);

    React.useEffect(() => {
        setFilteredTemplates(notificationPlugins.map(x => x[1]));
    }, [notificationPlugins]);

    const onCategorySelect = (e) => {
        const filtered = notificationPlugins.find(x => x[0] === formApi.getState().values.categorySelect);

        if (filtered) {
            setFilteredTemplates(filtered[1]);
        }
    }

    const onTemplateSelect = (e) => {
        const templateToSelect = filteredTemplates.find(ft => ft.Name === e.target.value);
        setTemplate(templateToSelect);
    }

    return (
        <>
            <div className="modal-body">
                <h2>Create Notification</h2>
                <div className="row">
                    <div className="col-md-4">
                        <div className="form-group">
                            <label htmlFor="categorySelect">Category</label>
                            <Dropdown field="categorySelect" onChange={onCategorySelect}>
                                <Option
                                    key={"OptionSetTypeBlank"}
                                    value={[]}
                                />
                                {notificationPlugins.map(np => (<Option key={np[0].replace(" ", "")} value={np[0]}>{np[0]}</Option>))}
                            </Dropdown>
                        </div>
                    </div>
                    <div className="col-md-8">
                        <div className="form-group">
                            <label htmlFor="selectedTemplate">Template</label>
                            <select multiple className="form-control" style={{ minHeight: 250 + 'px' }} id="selectedTemplate" onChange={onTemplateSelect}>
                                {filteredTemplates.map((np: NotificationPlugin) => (<option key={np.Id}>{np.Name}</option>))}
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" disabled={selectedTemplate === undefined} onClick={() => setPage()}>Next</button>
            </div>
        </>
    );
}

export const CreateNotificationSelectType = (props) => {
    return (
        <Form>
            <CreateNotificationSelectTypeForm {...props} />
        </Form>
    )
}
